import React, { ReactNode, createContext, useMemo } from "react";
import { TAuthContextValue } from "./auth/types";
import { useAuthController } from "./auth/useAuthController";

type TAuthProviderProps = {
  children: ReactNode;
};

export type { TAuthContextValue } from "./auth/types";

export const AuthContext = createContext<TAuthContextValue | undefined>(undefined);

const AuthProvider = ({ children }: TAuthProviderProps) => {
  const { state, refreshToken, performLoginRedirect, logout } = useAuthController();

  const contextValue = useMemo<TAuthContextValue | null>(() => {
    if (!state.msalInstance) return null;

    return {
      msalInstance: state.msalInstance,
      isLoggedIn: state.isLoggedIn,
      idToken: state.idToken,
      authError: state.authError,
      isMobileAuth: state.isMobileAuth,
      refreshToken,
      performLoginRedirect,
      logout,
    };
  }, [logout, performLoginRedirect, refreshToken, state]);

  if (state.isAuthenticating || !contextValue) return null;

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
